import { render, staticRenderFns } from "./PropertySummary.vue?vue&type=template&id=474458a2"
import script from "./PropertySummary.vue?vue&type=script&lang=js"
export * from "./PropertySummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports